/* import __COLOCATED_TEMPLATE__ from './posting-create-quote-actions.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, get } from '@ember/object';
import { APPLICATION_SOURCE } from 'sh-www/models/application';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-posting-create-direct-actions';
const CLASS_NAME_ALIGN = `${CLASS_NAME}--right`;

class PostingCreateQuoteActionsComponent extends Component {
  @service('states/routes/posting-create')
  state;

  @service('state-managers/routes/posting-create')
  stateManager;

  @service
  session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      CLASS_NAME_ALIGN,
    );
  }

  get isSubmitButtonDisabled() {
    return get(this.state, 'isCreatePostingRequestInFlight');
  }

  @action
  requestQuote() {
    this.stateManager.createDirectHireAssignment(APPLICATION_SOURCE.QUOTE);
  }
}

export default PostingCreateQuoteActionsComponent;
